import React from "react";
import DashboardCard from "../../../pages/home/common/DashboardCard";
import { convertThenFormat } from "../../common-data/Converts";

const UREstats = ({ calStatsCard, is_recurring }) => {
  return (
    <div className="cards-container cards-grid-container">
      {(!is_recurring || (is_recurring && is_recurring === "true")) && (
        <DashboardCard
          tagName={"ure"}
          cardLabel={"recurring"}
          value={`₹${convertThenFormat(
            calStatsCard?.total_recurring_price || 0
          )} (${convertThenFormat(calStatsCard?.total_recurring || 0)})`}
        />
      )}

      {(!is_recurring || (is_recurring && is_recurring === "false")) && (
        <DashboardCard
          tagName={"ure"}
          cardLabel={"non recurring"}
          value={`₹${convertThenFormat(
            calStatsCard?.total_non_recurring_price || 0
          )} (${convertThenFormat(calStatsCard?.total_non_recurring || 0)})`}
        />
      )}
    </div>
  );
};

export default UREstats;
